module.exports = __webpack_public_path__ + "static/media/sort-of-simple.104fd3dd.mp3";